module.exports = __webpack_public_path__ + "static/img/wuxian-bg.de98bcda.png";